import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '../../../../shared/utils/base.component';
import { SectionsService } from '../../../../services/sections.service';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { CommonModule } from '@angular/common';
import { UserService } from '../../../../services/user.service';
import { AuthorizationUtility } from '../../../../shared/authorization/auth.utility';
import { AuthorizationService } from "../../../../shared/authorization/authorization.service";

@Component({
  selector: 'ppl-auth-additional-details',
  standalone: true,
  imports: [NzGridModule,
    CommonModule
  ],
  templateUrl: './auth-additional-details.component.html',
  styleUrl: './auth-additional-details.component.css'
})
export class AuthAdditionalDetailsComponent extends BaseComponent implements OnInit{
  program: any;
  @Input() authData: any;
  @Input() pageId: any;
  @Input() tabId: any;
  viewComments = false;

  constructor(private sectionsService: SectionsService, private userService: UserService,
    private authUtility: AuthorizationUtility,
    private authService: AuthorizationService
  ){
      super();
  }

  ngOnInit(): void {
    this.program = this.userService.getSelectedProgram();
    const secData = this.sectionsService.getSectionData(
      this.program.program_code,
      'payroll'
    );
    this.secData = secData.additionalDetails;
    this.viewComments = this.authUtility.isSectionEditable('AUTHORIZATION_MEMBER_VIEW', this.tabId, 'Auth_Details_Comments');
    this.setPageAccess();
  }

  private setPageAccess() {
    const pageConfig = this.authUtility.getPageConfig(this.pageId);
    if(!pageConfig || !pageConfig.pageName) {
      this.authService.fetchPageAuthorization(this.program.program_code,'AUTHORIZATION_MEMBER_VIEW', "DETAIL").subscribe((response: any) => {
        this.viewComments = this.authUtility.isSectionEditable('AUTHORIZATION_MEMBER_VIEW', this.tabId, 'Auth_Details_Comments');
      })
    }
  }

}
